import React from 'react';
import './Specialpe.css';

const Specialpe = () => {
  return (
    <div className="Specialp-container">
      <h2 className="Specialp-heading">FEATURES</h2>

      <div className="Specialp-card"> 
        

        <ul className="Specialp-list" data-aos="fade-down">
          <li><strong>Special PE Material Tube  –</strong> fast melting speed and good color mixing effect.</li>
          <li><strong>Increased Hydraulic Circuit –</strong> increase injection and melting speed.</li>
          <li><strong>Improved Frame Structure  –</strong> more making barrel requirements.</li>
          <li><strong>Customized Product Slidese –</strong> products fall out automatically, increasing productivity.</li>
        </ul>
      </div>
    </div>
  );
};

export default Specialpe;
